var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.87807 4.6007C8.07807 1.1407 2.86807 1.1307 2.06807 4.6007C1.59807 6.6307 2.88807 8.3507 4.00807 9.4207C4.82807 10.1907 6.11807 10.1907 6.93807 9.4207C8.05807 8.3507 9.33807 6.6307 8.87807 4.6007ZM5.50807 6.2007C4.95807 6.2007 4.50807 5.7507 4.50807 5.2007C4.50807 4.6507 4.94807 4.2007 5.49807 4.2007H5.50807C6.06807 4.2007 6.50807 4.6507 6.50807 5.2007C6.50807 5.7507 6.06807 6.2007 5.50807 6.2007Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51562 5.19922C6.51562 5.74922 6.07562 6.19922 5.51562 6.19922C4.96562 6.19922 4.51562 5.74922 4.51562 5.19922C4.51562 4.64922 4.95562 4.19922 5.50562 4.19922H5.51562C6.07562 4.19922 6.51562 4.64922 6.51562 5.19922Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.908 16.6007C21.108 13.1407 15.878 13.1307 15.068 16.6007C14.598 18.6307 15.888 20.3507 17.018 21.4207C17.838 22.1907 19.138 22.1907 19.958 21.4207C21.088 20.3507 22.378 18.6307 21.908 16.6007ZM18.528 18.2007C17.978 18.2007 17.528 17.7507 17.528 17.2007C17.528 16.6507 17.968 16.2007 18.518 16.2007H18.528C19.078 16.2007 19.528 16.6507 19.528 17.2007C19.528 17.7507 19.078 18.2007 18.528 18.2007Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5312 17.1992C19.5312 17.7492 19.0812 18.1992 18.5312 18.1992C17.9812 18.1992 17.5312 17.7492 17.5312 17.1992C17.5312 16.6492 17.9712 16.1992 18.5212 16.1992H18.5312C19.0812 16.1992 19.5312 16.6492 19.5312 17.1992Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0014 19.75H9.32141C8.16141 19.75 7.15141 19.05 6.75141 17.97C6.34141 16.89 6.64141 15.7 7.51141 14.93L15.5014 7.94C15.9814 7.52 15.9914 6.95 15.8514 6.56C15.7014 6.17 15.3214 5.75 14.6814 5.75H12.0014C11.5914 5.75 11.2514 5.41 11.2514 5C11.2514 4.59 11.5914 4.25 12.0014 4.25H14.6814C15.8414 4.25 16.8514 4.95 17.2514 6.03C17.6614 7.11 17.3614 8.3 16.4914 9.07L8.50141 16.06C8.02141 16.48 8.01141 17.05 8.15141 17.44C8.30141 17.83 8.68141 18.25 9.32141 18.25H12.0014C12.4114 18.25 12.7514 18.59 12.7514 19C12.7514 19.41 12.4114 19.75 12.0014 19.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouting);
export default __webpack_public_path__ + "static/media/routing.919a04a49d8fb53526ca5da866b61c59.svg";
export { ForwardRef as ReactComponent };